module.exports = __webpack_public_path__ + "static/media/beyond-meat-explore-more.f6eedc38.jpg";